export default "__VITE_ASSET__1ba1023d__"